export default {
    methods: {
        getChartTranslations() {
            return {
                    downloadCSV: this.$i18n.t('chart.downloadCSV'),
                    downloadJPEG: this.$i18n.t('chart.downloadJPEG'),
                    downloadPDF: this.$i18n.t('chart.downloadPDF'),
                    downloadPNG: this.$i18n.t('chart.downloadPNG'),
                    downloadSVG: this.$i18n.t('chart.downloadSVG'),
                    downloadXLS: this.$i18n.t('chart.downloadXLS'),
                    loading: this.$i18n.t('chart.loading'),
                    shortMonths: this.$i18n.t('chart.shortMonths'),
                    noData: this.$i18n.t('chart.noData'),
                    printChart: this.$i18n.t('chart.printChart'),
                    resetZoom: this.$i18n.t('chart.resetZoom'),
                    resetZoomTitle: this.$i18n.t('chart.resetZoomTitle'),
                    viewFullscreen: this.$i18n.t('chart.viewFullscreen'),
                    weekdays: this.$i18n.t('chart.weekdays')
                }
        },
        getChartExportingOptions() {
            return {
                buttons: {
                    contextButton: {
                        menuItems: [
                            "printChart",
                            "separator",
                            "downloadPNG",
                            "downloadJPEG",
                            "downloadPDF",
                            "downloadSVG",
                            "separator",
                            "downloadCSV",
                            "downloadXLS"
                        ]
                    }
                }
            }
        }
    }
};